var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryTick = function SvgPrimaryTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#37CB1D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m20.991 34.943-8.125-8.125a1.25 1.25 0 0 1 0-1.767l1.768-1.768a1.25 1.25 0 0 1 1.768 0l5.473 5.473 11.723-11.723a1.25 1.25 0 0 1 1.768 0l1.768 1.768a1.25 1.25 0 0 1 0 1.767L22.759 34.943a1.25 1.25 0 0 1-1.768 0"
  }))));
};
export default SvgPrimaryTick;